<template>
    <div class="top_page">
        <div class="w1180">
        <!-- <languages /> -->
        <!-- <div class="help sever" @click="handleGoUrl('help')">
            <span>{{ $t('newHome.Help') }}</span>
        </div>
        <div class="online sever" @click="handleGoUrl()">
            <span><em class="online_icon"></em> {{ $t('newHome.online') }}</span>
        </div> -->
            <!-- <div class="facebook sever" @click="handleGoUrl('Facebook')">
                <span><em class="facebook_icon"></em> {{ $t('newHome.Facebook') }}</span>
            </div>  -->
            <div class="telegram sever" @click="handleGoUrl('telegram')">
                <span><em class="telegram_icon"></em> {{ $t('newHome.telegram') }}</span>
            </div>   
            <div class="whatsapp sever" @click="handleGoUrl('whatsapp')">
                <span><em class="whatsapp_icon"></em> {{ $t('newHome.whatsapp') }}</span>
            </div>
            <a class="email sever" :href="'mailto:'+contact_email">
                <span><em class="email_icon"></em> {{ $t('newHome.email') }}</span>
            </a>  
            <!-- <div class="email sever" @click="handleGoUrl('email')">
                <span><em class="email_icon"></em> {{ $t('newHome.email') }}</span>
            </div>  -->
        </div>                        
    </div>

</template>

<script>
import { mapState, mapMutations,mapActions} from 'vuex'
import languages from '../common/languages.vue'
export default {
    components:{ languages },
    data(){
        return {
        }
    },
    computed: {
      ...mapState({
        Facebook: state => state.FrontConfigList.Facebook,
        telegram: state => state.FrontConfigList.telegram,
        whatsapp: state => state.FrontConfigList.whatsapp,
        contact_email: state => state.FrontConfigList.contact_email,
      }),
    },
    methods:{
        handleGoUrl(type){
            if(type == 'help'){
                 return this.$router.push({ path:'/helpCenter/startUse',query:{ id:4}});
            }else if(type == 'Facebook'){
                return window.open(this.Facebook);
            }else if(type == 'telegram'){
                return window.open(this.telegram);
            }else if(type == 'whatsapp'){
                return window.open(this.whatsapp);
            }else if(type == 'email'){
                return window.open(this.contact_email);
            }else{
               window.LiveChatWidget ? window.LiveChatWidget.call('maximize') : '' 
            } 
        }
    }
}
</script>

<style lang="scss" scoped>
.top_page{    
    background: #f9f9f8;
    height: 30px;
    .w1180{width: 1180px; margin: 0 auto;}
    .sever{
        display: inline-block;
        cursor: pointer;
        font-family: Roboto-Bold;
        font-size: 14px;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #000;
        line-height: 30px;
        vertical-align: middle;
        &::before{
            content:'';
            display:inline-block;
            overflow: hidden;
            width:20px;
            height:26px;
            margin-right:5px;
            vertical-align: middle;
        }
        .online_icon{
            display: inline-block;
            width: 25px;
            height: 25px;
            margin-right: 2px;
            vertical-align: middle;
            background-image:url('./img/header_service.png');
            background-size: contain;
        }
        .facebook_icon{
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            background-image:url('./img/header_facebook.png');
            background-size: contain;
        }    
        .telegram_icon{
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            background-image:url('./img/header_telegram.png');
            background-size: contain;
        }  
        .whatsapp_icon{
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            background-image:url('./img/header_whatapp.png');
            background-size: contain;
        }       
        .email_icon{
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            background-image:url('./img/header_email.png');
            background-size: contain;
        }                
    }
    
}
</style>


// WEBPACK FOOTER //
// src/pages/build901/components/Header/serve.vue